// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { IsoCurrencyCode } from '@/currency/constants/iso';
import { formatCurrencyValue } from '@/currency/utilities/format';
import { parseCurrencyAmount } from '@/currency/utilities/validate';
import { ACCOUNTING_PADDING } from '@/utilities/number';

/** Formats a rollforward amount accounting style, with negatives in parentheses. */
export function formatRollforwardAmount(
  amount: string,
  currencyCode: IsoCurrencyCode,
  isOutflow: boolean
): string {
  const parsed = parseCurrencyAmount(amount);
  if (parsed === null) {
    throw new Error(`Unparseable rollforward amount: "${amount}"`);
  }

  const signed = isOutflow ? parsed.negated() : parsed;
  if (signed.isNegative() && !signed.isZero()) {
    return `(${formatCurrencyValue({ amount: signed.abs(), isoCode: currencyCode }, { sparse: true })})`;
  }

  return `${formatCurrencyValue({ amount: signed, isoCode: currencyCode }, { sparse: true })}${ACCOUNTING_PADDING}`;
}
